<template>
  <header>
    <div class="container d-flex align-items-center h-100">
      <router-link to="/" class="logo" href="/">
        <img
          srcset="
            @/images/logo/logo@3x.png 3x,
            @/images/logo/logo@2x.png 2x,
            @/images/logo/logo@1x.png 1x
          "
          src="@/images/logo/logo@1x.png"
          alt="logo"
        />
        <span>Data</span>
      </router-link>
      <div class="hamburger" @click="toggleMenu" :class="{'active': isMenuActive}"></div>
      <nav :class="{'active': isMenuActive}">
          <router-link @click="toggleMenu" to="/prediction" :class="{'active': $route.name == 'prediction' || $route.meta?.pageClass == 'prediction'}">Prediction</router-link>
          <router-link @click="toggleMenu" to="/reports" :class="{'active': $route.name == 'reports' || $route.meta?.pageClass == 'reports'}">Reports</router-link>
          <router-link @click="toggleMenu" to="/about-ai" :class="{'active': $route.name == 'about-ai'}">About AI</router-link>
          <router-link @click="toggleMenu" to="/investment" :class="{'active': $route.name == 'investment'}">Invest</router-link>
          <a href="https://ooyyo.com" target="_blank">Car search</a>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  data() {
    return {
      isMenuActive: false
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuActive = !this.isMenuActive;
    }
  }
};
</script>

<style lang="scss">
    .logo {
        width: 150px;
        display: block;
        position: relative;
        img {
            max-height: 100%;
            max-width: 100%;
        }
        span {
            position: absolute;
            top: 40px;
            right: 20px;
            font-size: 12px;
            text-transform: uppercase;
            color: white;
            &:hover {
                cursor: pointer;
                color: white;
            }
        }
    }
    nav {
        margin-left: auto;
        a {
            margin-left: 24px;
            color: #999;
            text-transform: uppercase;
            &:hover {
                color: white;
            }
        }
    }
</style>
